import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  BundleUpdateCheckResponse,
  BundleUpdateErrorModel,
  BundleUpdateStatusResponse,
  ViError,
  XotaBundleUpdateStep,
} from '@vi-iot/client';

import { FirmwareUpdateStep } from './firmware-update.model';

export namespace FirmwareUpdateActions {
  export const setFirmwareUpdateStep = createAction(
    '[FIRMWARE ACTIONS] Set firmware update step',
    props<{ step: FirmwareUpdateStep }>()
  );

  export const setXotaBundleUpdateStep = createAction(
    '[FIRMWARE ACTIONS] Set bundle update step',
    props<{ bundleUpdateStep: XotaBundleUpdateStep }>()
  );

  export const onCloseFirmwareUpdateModal = createAction(
    '[FIRMWARE ACTIONS] On close firmware update modal'
  );

  export const openFirmwareUpdateModal = createAction(
    '[FIRMWARE ACTIONS] Open Firmware Update modal',
    props<{
      gatewaySerial: string;
    }>()
  );

  export const openOneTimeServiceApproval = createAction(
    '[FIRMWARE ACTIONS] Open One Time Service Approval modal',
    props<{
      gatewaySerial: string;
    }>()
  );

  export const checkingSalesForceCodeForCheckProcess = createAction(
    '[FIRMWARE ACTIONS] checking apply sales force case number in check process',
    props<{
      salesForceCaseNumber: string;
    }>()
  );

  export const checkingSalesForceCodeForCheckProcessSuccess = createAction(
    '[FIRMWARE ACTIONS] checking apply sales force code in check process success',
    props<{
      response: BundleUpdateCheckResponse;
    }>()
  );

  export const checkingSalesForceCodeForCheckProcessError = createAction(
    '[FIRMWARE ACTIONS] checking apply sales force code in check process error',
    props<{
      error: BundleUpdateErrorModel;
    }>()
  );

  export const checkingSalesForceCodeForUpdateProcess = createAction(
    '[FIRMWARE ACTIONS] checking apply sales force case number in update process',
    props<{
      salesForceCaseNumber: string;
    }>()
  );

  export const checkingSalesForceCodeForUpdateProcessSuccess = createAction(
    '[FIRMWARE ACTIONS] checking apply sales force code in update process success',
    props<{
      response: BundleUpdateCheckResponse;
    }>()
  );

  export const checkingSalesForceCodeForUpdateProcessError = createAction(
    '[FIRMWARE ACTIONS] checking apply sales force code in update process error',
    props<{
      error: BundleUpdateErrorModel;
    }>()
  );

  export const checkUpdateTimeBlock = createAction('[FIRMWARE ACTIONS] Check update time block');

  export const checkUpdateTimeBlockSuccess = createAction(
    '[FIRMWARE ACTIONS] Check update time block success',
    props<{
      isInUpdateTimeBlock: boolean;
    }>()
  );

  export const checkUpdateTimeBlockError = createAction(
    '[FIRMWARE ACTIONS] Check update time block error'
  );

  export const checkUpdateVerification = createAction(
    '[FIRMWARE ACTIONS] Check update verification'
  );

  export const checkUpdateVerificationSuccess = createAction(
    '[FIRMWARE ACTIONS] Check update verification success',
    props<{
      response: BundleUpdateCheckResponse;
    }>()
  );

  export const checkUpdateVerificationError = createAction(
    '[FIRMWARE ACTIONS] Check update verification error',
    props<{
      error: BundleUpdateErrorModel;
    }>()
  );

  export const setOverallProgress = createAction(
    '[FIRMWARE ACTIONS] set progress when getting version list'
  );

  export const setOverallProgressSuccess = createAction(
    '[FIRMWARE ACTIONS] set progress when getting version list success',
    props<{ bundleUpdateStatusResponse: BundleUpdateStatusResponse; gatewaySerial: string }>()
  );

  export const setOverallProgressError = createAction(
    '[FIRMWARE ACTIONS] set progress when getting version list failed',
    props<{ error: BundleUpdateErrorModel }>()
  );

  export const setOverallProgressFirmwareUpdate = createAction(
    '[FIRMWARE ACTIONS] set progress when updating'
  );

  export const setOverallProgressFirmwareUpdateSuccess = createAction(
    '[FIRMWARE ACTIONS] set progress when updating success',
    props<{ bundleUpdateStatusResponse: BundleUpdateStatusResponse; gatewaySerial: string }>()
  );

  export const setOverallProgressFirmwareUpdateError = createAction(
    '[FIRMWARE ACTIONS] set progress when updating failed',
    props<{ error: BundleUpdateErrorModel }>()
  );

  export const showUpToDate = createAction(
    '[FIRMWARE ACTIONS] show up to date modal',
    props<{
      bundleUpdateStatusResponse: BundleUpdateStatusResponse;
    }>()
  );

  export const showFirmwareBundleUpdate = createAction(
    '[FIRMWARE ACTIONS] show bundle list of firmware update',
    props<{
      bundleUpdateStatusResponse: BundleUpdateStatusResponse;
    }>()
  );

  export const checkUpdateFirmwareVerification = createAction(
    '[FIRMWARE ACTIONS] Check update firmware before updating verification'
  );

  export const checkUpdateFirmwareVerificationSuccess = createAction(
    '[FIRMWARE ACTIONS] Check update firmware before updating verification success',
    props<{
      response: BundleUpdateCheckResponse;
    }>()
  );

  export const checkUpdateFirmwareVerificationError = createAction(
    '[FIRMWARE ACTIONS] Check update firmware before updating verification error',
    props<{
      error: BundleUpdateErrorModel;
    }>()
  );

  export const triggerUpdateFirmware = createAction(
    '[FIRMWARE ACTIONS] trigger updating the firmware'
  );

  export const xota1showFirmwareBundleAfterUpdate = createAction(
    '[FIRMWARE ACTIONS] XOTA 1 - show bundle list of firmware after update',
    props<{ bundleUpdateStatusResponse: BundleUpdateStatusResponse; gatewaySerial: string }>()
  );

  export const xota2showProcessStatusAfterUpdate = createAction(
    '[FIRMWARE ACTIONS] XOTA 2 - show operation process status after update',
    props<{
      bundleUpdateStatusResponse: BundleUpdateStatusResponse;
      gatewaySerial: string;
    }>()
  );

  export const clearLocalStorageKey = createAction(
    '[FIRMWARE ACTIONS] Clear local storage key',
    props<{ gatewaySerial: string }>()
  );

  export const saveFirmwareUpdateStateToLocal = createAction(
    '[FIRMWARE ACTIONS] Save local storage of firmware update',
    props<{ gatewaySerial: string }>()
  );

  export const stopApiCallsOnProgressEnd = createAction(
    '[FIRMWARE ACTIONS] Canceling check update progress API'
  );

  export const verifyGateway = createActionGroup({
    source: 'FIRMWARE ACTIONS Verify gateway',
    events: {
      attempt: emptyProps(),
      success: props<{ value: boolean }>(),
      errror: props<{ error: ViError }>(),
    },
  });
}
